import { createFileRoute } from "@tanstack/react-router";

import { ArchivedThreadsPanel } from "../components/settings/ArchivedThreadsSettings";

export const Route = createFileRoute("/settings/archived")({
  component: ArchivedThreadsPanel,
});
